import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import TabbedPipeline from "./tabbed_pipeline/TabbedPipeline";
import QuickLinks from "./QuickLinks";
import Welcome from "./Welcome";

function HomepageContent() {
  return (
    <PageWrapper>
      <Welcome />
      <TabbedPipeline />
      <QuickLinks />
    </PageWrapper>
  );
}

const PageWrapper = styled(Flex)({
  flexDirection: "column" as const,
  flexGrow: 1,
  flexShrink: 0,
  gap: "48px",
  height: "fit-content",
  width: "100%",
  maxWidth: "1200px",
  justifyContent: "center",
  margin: "0 auto",
  padding: "48px 24px",

  "@media screen and (min-width: 992px)": {
    padding: "48px",
  },
});

export default HomepageContent;
